import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Authorize from '../../components/AuthComponent/Authorize';
import SaveButton from '../../components/Buttons/SaveButton';
import ButtonBar from '../../components/Fields/ButtonBar';
import DateControl from '../../components/Fields/DateControl';
import Field from '../../components/Fields/Field';
import FieldLabel from '../../components/Fields/FieldLabel';
import Form from '../../components/Fields/Form';
import TextboxField from '../../components/Fields/TextboxField';
import { FormConfig } from '../../components/Fields/Types';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import { HorizontalTabs } from '../../components/Tabs/HorizontalTabs';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import PriceTrancheTypeModel from '../../models/PriceTrancheTypeModel';
import DataService from '../../services/data.service';
import { Result } from '../../types/Result';
import FormatUtils from '../../utils/FormatUtils';
import Unauthorized from '../Authentication/Unauthorized';
import PriceTrancheType_tab_Volumes from './Tabs/PriceTrancheType_tab_Volumes';

const PriceTrancheTypeView: React.FC = () => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [isAuthorized, setIsAuthorized] = useState<boolean>(true);
    const [formData, setFormData] = useState<PriceTrancheTypeModel>()
    const navigate = useNavigate()

    const priceTrancheTypeId = useParams().id

    useEffect(() => {
        if (priceTrancheTypeId) {
            if (priceTrancheTypeId == 'add')
                setFormData({
                    id: 0,
                    name: '',
                    beginDate: new FormatUtils().formatDateForStorage(new Date()),
                    endDate: '',
                    concurrencyId: ''
                })
            else
                DataService.getById<PriceTrancheTypeModel>('api/v1/pricetranchetypes/', priceTrancheTypeId)
                    .then(response => setFormData(response))
                    .catch(e => {
                        if (e.response?.data?.status === 401)
                            setIsAuthorized(false);
                        else
                            handleException(e);
                    });
        }
    }, [priceTrancheTypeId]);

    function submit() {
        if (formData) {
            if (formData.id === 0)
                DataService
                    .create<PriceTrancheTypeModel>(`api/v1/pricetranchetypes/`, formData)
                    .then(response => {
                        handleResult(response);
                        setServerErrors(response);
                        if (response.isSuccesful === true && response.data)
                            navigate('/plm/ItemSetup/PriceTrancheTypes')
                    })
                    .catch(e => handleException(e));
            else
                DataService
                    .update<PriceTrancheTypeModel>(`api/v1/pricetranchetypes/`, formData)
                    .then(response => {
                        handleResult(response);
                        setServerErrors(response);
                        if (response.isSuccesful === true && response.data)
                            setFormData(response.data);
                    })
                    .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'name', label: 'Name', labelSize:4, validationRules: [{ type: 'isRequired' }] },
            { name: 'beginDate', label: 'Active from', labelSize: 4, validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'endDate', label: 'Active Until', labelSize: 'auto', validationRules: [{ type: 'isDate' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getLabelProps, getControlProps, getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    const { isAuthorizedFor } = useAuth();
    if (priceTrancheTypeId === undefined) {
        if (!isAuthorizedFor(ApplicationFunctions.EditPriceTrancheType)) {
            return (<Unauthorized />);
        }
    }
    else if (!isAuthorized) {
        return (<Unauthorized />);
    }

    return (
        <div className='main-content'>
            <Form title='Pricetranche type' footer={(
                <Row>
                    <Col md='12'>
                        <ButtonBar offset={1}>
                            <Authorize applicationFunction={ApplicationFunctions.EditPriceTrancheType}>
                                <SaveButton  {...getSubmitButtonProps()} />
                            </Authorize>
                        </ButtonBar>
                    </Col>
                </Row>
            )}>
                <Container fluid>
                    <Row>
                          <Col md='6'>
                            <TextboxField {...getFieldProps('name')} />
                            <Field {...getLabelProps('beginDate')}>
                                <DateControl {...getControlProps('beginDate')} />
                                <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('endDate')} /></span>
                                <DateControl {...getControlProps('endDate')} />
                            </Field>
                        </Col>
                    </Row>
                </Container>
            </Form>
            {priceTrancheTypeId && priceTrancheTypeId !== 'add' && (
                <Container fluid>
                    <Row>
                        <Col md='12'>
                            <HorizontalTabs
                                id='vtabs'
                                defaultActiveKey='volumes'
                                tabs={[
                                    {
                                        title: 'Volumes',
                                        eventKey: 'volumes',
                                        component: <PriceTrancheType_tab_Volumes id={parseInt(priceTrancheTypeId)} />,
                                    },
                                ]}
                            />
                        </Col>
                    </Row>
                </Container>
            )}

        </div>
    );
}
export default PriceTrancheTypeView;